import { gql } from "@apollo/client";

const CREATE_CREDIT_MEMO_BATCH = gql`
  mutation CreateCreditMemoBatch($params: CreateCreditMemoBatchInput!) {
    createCreditMemoBatch(params: $params) {
      msg
      msgId
      operationBatchId
      results {
        status
        error
        creditMemoId
        creditMemoAmount
        deductionId
        createdBy
        customerId
        linkedCreditMemo {
          creditMemoId
          creditMemoDocumentNumber
          creditMemoTransactionDate
          creditMemoDescription
          invoiceDocumentNumbers
          customerName
          deductionType
          customerId
        }
      }
    }
  }
`;

export default CREATE_CREDIT_MEMO_BATCH;
